import { NsCard } from 'components/common/ns-card/NsCard';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { FUEL_OPTIONS, METER_TYPE_ERROR_CODES } from 'config/app-config';
import { capitalize } from 'utils/misc';
import { actionUrl } from 'config/static-content';
import { TrackedCta } from 'components/direct-sales/select-options/components/TrackedCta';

const {
  MeterMeasurementClassException,
  MeterProfileClassException
} = METER_TYPE_ERROR_CODES;

type DataMaping = {
  gas: boolean;
  electric: boolean;
  decoration: 'dualFuel' | 'gas' | 'bulb' | undefined;
  fuelName: string;
  content: string;
};

const dataMaping: DataMaping[] = [
  {
    gas: true,
    electric: true,
    decoration: 'dualFuel',
    fuelName: 'Energy',
    content: 'Your meters are currently classified as non-domestic.' // TODO: confirm this messaging
  },
  {
    gas: true,
    electric: false,
    decoration: 'gas',
    fuelName: capitalize(FUEL_OPTIONS.GAS),
    content: 'Your gas meter is currently classified as non-domestic.'
  },
  {
    gas: false,
    electric: true,
    decoration: 'bulb',
    fuelName: capitalize(FUEL_OPTIONS.ELECTRIC),
    content: 'Your electricity meter is currently classified as non-domestic.'
  }
];

const getData = ({ gas, electric }) => {
  return (
    dataMaping.find(
      (data) => data.gas === gas && data.electric === electric
    ) ?? { decoration: undefined, fuelName: '', content: '' }
  );
};

const checkError = (fuel, errors) => {
  const fuelErrors = errors.filter((error) => error.keyword === fuel);

  return fuelErrors.some((error) => error.code === MeterProfileClassException);
};

type BgLiteCardProps = {
  errors: {
    code: typeof METER_TYPE_ERROR_CODES[keyof typeof METER_TYPE_ERROR_CODES];
    keyword: 'Gas' | 'Electricity';
  }[];
  name: string;
};

export const BgLiteCard = ({ errors, name }: BgLiteCardProps) => {
  // unmetered error should take precedence if found so we don't show the BGLite card
  const hasUnmeteredError = errors.some(
    (error) => error.code === MeterMeasurementClassException
  );
  const isGasNonDomestic = checkError('Gas', errors);
  const isElectricityNonDomestic = checkError('Electricity', errors);
  const { decoration, content, fuelName } = getData({
    gas: isGasNonDomestic,
    electric: isElectricityNonDomestic
  });
  const hasAnyNonDomesticError = isGasNonDomestic || isElectricityNonDomestic;
  const shouldShow = !hasUnmeteredError && hasAnyNonDomesticError;

  if (!shouldShow) {
    return null;
  }

  return (
    <NsCard
      heading={`Manage your ${fuelName} supply`}
      decoration={decoration}
      testId="bgLiteCardTestId"
      action={
        <TrackedCta name={name}>
          <NsPrimaryCta href={actionUrl.bgLite} testId="bgLiteCtaTestId">
            Go to British Gas Lite
          </NsPrimaryCta>
        </TrackedCta>
      }
    >
      <p>{content}</p>
    </NsCard>
  );
};
